import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BusinessEmailDetails, EmailDetails } from '../contact-forms.model';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { observable } from 'rxjs';

@Injectable()
export class ContactFormsService {
  formStored: EventEmitter<boolean> = new EventEmitter();
  resetForm: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private http: HttpClient,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  callWebhook(emailContent: EmailDetails) {
    console.log('calling webhook');
    this.http
      .post(environment.webhook_url, {
        subject: '[PAXI] Customer Contact',
        ...emailContent,

      },
      {
        responseType: 'text',
      }
  )
      .subscribe({
        next: () => {
          console.log('Sent on webhook');
        },
        error: (error) => console.error('Error sending on webhook', error),
        complete: () => console.log('done-webhook'),
      });
  }

  sendMail(emailContent: EmailDetails) {
    this.recaptchaV3Service
      .execute('CONTACTFORM')
      .subscribe((recaptchaResponse) => {
        this.http
          .post(environment.api_url, {
            recaptchaToken: recaptchaResponse,
            to: emailContent.email,
            from: 'mailer@paxiplatform.com',
            subject: '[PAXI] Customer Contact',
            html: this.formatContactForm(emailContent),
          })
          .subscribe({
            next: () => this.formStored.emit(true),
            error: () => this.formStored.emit(false),
            complete: () => console.log('done'),
          });
      });
  }

  formatContactForm(emailContent: EmailDetails): string {
    return `
      <ul>
        <li>
          <p>Full Name</p>
          <p>${emailContent.fullName}</p>
        </li>
        <li>
          <p>Phone Number</p>
          <p>${emailContent.phoneNumber}</p>
        </li>
        <li>
          <p>Tracking Number</p>
          <p>${emailContent.trackingNumber}</p>
        </li>
        <li>
          <p>Type</p>
          <p>${emailContent.type}</p>
        </li>
        <li>
          <p>Query Type</p>
          <p>${emailContent.queryType}</p>
        </li>
        <li>
          <p>Email</p>
          <p>${emailContent.email}</p>
        </li>
        <li>
          <p>Message</p>
          <p>${emailContent.message}</p>
        </li>
      </ul>
    `;
  }

  formatBusinessContactForm(emailContent: BusinessEmailDetails): string {
    return `
      <ul>
        <li>
          <p>Full Name</p>
          <p>${emailContent.fullName}</p>
        </li>
        <li>
          <p>Phone Number</p>
          <p>${emailContent.phoneNumber}</p>
        </li>
        <li>
          <p>Company Name</p>
          <p>${emailContent.companyName}</p>
        </li>
        <li>
          <p>Email</p>
          <p>${emailContent.email}</p>
        </li>
        <li>
          <p>Message</p>
          <p>${emailContent.message}</p>
        </li>
      </ul>
    `;
  }
}
